import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { cancelMyActivityBooking } from "../../../action/activityBooking";
import { scrollToTop } from "../../../JS/scrollToTop";
  

const ActivityBookingCancelPopUp = (props) => {
  
    const { t } = props

    const [loading, setLoading] = useState(false);
 
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
    let widgetSesstionId = localStorage.getItem("activityBookingSessionToken");

    const sendTheAnalytics = (isSuccess) => {
        try {

            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                isSuccess ? "CANCEL RESERVATION - Success" : "CANCEL RESERVATION - Fail" ,
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "deleteReservationID": props.appointmentId },
                0,
                props.guestIsLoggedIn
            );
        } catch (error) {
            return error;
        }

    }

    const handleDeleteReservation = async () => {
        setLoading(true);
        let deletedSuccessfully = true;
        console.log("appointmentid for cancle", props.appointmentId)
        const payload = {
            serviceType: "activity", 
            appointmentId: props.appointmentId,
         };
         let msg;
        try {
            const res = await cancelMyActivityBooking(payload);
            if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {
                sendTheAnalytics(true);
            } else {
                deletedSuccessfully = false;
                sendTheAnalytics(false);
            }
            msg = (res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg);
        } catch (err) {
            console.log(err);
            deletedSuccessfully = false;
        }  

        setLoading(false);
        props.handleDeleteReservation(deletedSuccessfully,msg);
    };


    React.useEffect(() => {
        console.log(props.appointmentId)
        scrollToTop();
    }, [])
     
    return (
        <>
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{ color: "#000 !important" }}>{t('activityBooking.cancelPopup.heading1')}</h2>
                                    <p>{t('activityBooking.cancelPopup.subHeading')}</p>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                   

                        <div class="overlay-controls">
                            {loading ? <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('activityBooking.cancelling')}</button> : <button onClick={() => handleDeleteReservation()} class="button">{t('activityBooking.proceed')}</button>}
                            <button onClick={() => props.close()} disabled={loading} class="button secondary">{t('activityBooking.close')}</button>
                        </div>
                    </div>
                </div>
            </section>

            
        </>
    )
}


const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(ActivityBookingCancelPopUp));